import styled from 'styled-components'

import { media } from '../../../utils/mediaQuery'

export const TooltipContainer = styled.div<{ $x: number; $y: number }>`
  position: absolute;
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
  background: white;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  pointer-events: none;
  max-width: 240px;
  transform: translate(-50%, -100%);
  margin-top: -16px;

  ${media.tabletDown} {
    max-width: 250px;
    padding: 8px;
  }

  @media (max-width: 480px) {
    max-width: 200px;
    padding: 6px;
  }

  /* Tooltip arrow */
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid white;
  }
`

export const TooltipOverlapHint = styled.div`
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #eee;
  font-size: 10px;
  color: #999;
  cursor: pointer;
`

export const PopoverContainer = styled.div<{ $x: number; $y: number }>`
  position: absolute;
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  z-index: 1001;
  min-width: 180px;
  max-width: 280px;
  max-height: min(360px, calc(100% - 32px));
  transform: translate(-50%, -100%);
  margin-top: -12px;
  pointer-events: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: white;
  }
`

export const PopoverHeader = styled.div`
  padding: 6px 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #eee;
  font-size: 11px;
  font-weight: 600;
  color: #555;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`

export const PopoverCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  padding: 0 2px;
  line-height: 1;

  &:hover {
    color: #333;
  }
`

export const PopoverList = styled.div`
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  flex: 1;
  min-height: 0;
`

export const PopoverScrollHint = styled.div`
  min-height: 30px;
  padding: ${({ theme }) => `${theme.spacing.xsmall} ${theme.spacing.small}`};
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background.secondary};
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  flex-shrink: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};
`

export const PopoverItem = styled.div`
  padding: 6px 10px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.15s;

  &:hover {
    background: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }
`
